import React, { useMemo } from 'react';
import type { CardPlugin } from '@atlaskit/editor-plugin-card';
import type { PublicPluginAPI } from '@atlaskit/editor-common/types';
import { expVal } from '@atlassian/jira-feature-experiments';
import { AiProactiveDescriptionCompleter } from './index.tsx';
import type { EditorExperience } from './types.tsx';

export const useProactiveDescriptionCompleterContentComponent = (
	editorApi: PublicPluginAPI<[CardPlugin]> | null,
	editorExperience: EditorExperience,
) => {
	const experimentFeatureGateValue =
		editorExperience === 'IssueView'
			? expVal('experiment_proactive_desc_completer_issueview', 'isEnabled', false)
			: expVal('experiment_proactive_desc_completer_gic', 'isEnabled', false);

	return useMemo(
		() =>
			experimentFeatureGateValue
				? {
						before: <></>,
						after: (
							<AiProactiveDescriptionCompleter
								editorApi={editorApi}
								editorExperience={editorExperience}
							/>
						),
					}
				: undefined,
		[editorApi, editorExperience, experimentFeatureGateValue],
	);
};
